// @flow

import React from 'react'

import { eventMeta } from '@raywhite/helpers-utils/lib/helpers/link'

type Props = {
  label: string,
  onClick: () => void,
}

const appraisalMeta = eventMeta({
  category: 'Appraisal',
  action: 'Open',
  label: 'Site',
})

const AppraisalButton = ({
  label = 'Book a Free Appraisal',
  onClick,
}: Props) => {
  // Note: see optimize account for experiments related to these variations
  const tabletButton = (
    <a
      onClick={onClick}
      className="home_header_cta btn brand_btn no_arrow tablet"
      {...appraisalMeta}
    >
      {label}
    </a>
  )
  const mobileButton = (
    <a
      onClick={onClick}
      className="home_header_cta btn light mobile"
      {...appraisalMeta}
    >
      {label}
    </a>
  )

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      {tabletButton}
      {mobileButton}
    </div>
  )
}

export default AppraisalButton
